import BaseList from '@/containers/BaseList'

export default (module) => ({
  functional: true,
  components: {
    BaseList,
  },
  render (h, { props }) {
    return (
      <BaseList source={module} error={props.error} key={`${module}list`} />
    )
  },
})
